import React, { memo } from 'react';
import LoadingIndicator from '@components/details/loading-indicator';
import Drawer from '@components/entity/info/drawer';
import Map from '@components/entity/info/map';
import './info.scss';

const Info = () => {
  return (
    <div styleName="info-container">
      <LoadingIndicator />
      <Drawer />
      <Map />
    </div>
  );
};

export default memo(Info);
